import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Logo from "../assets/images/logo.png";
import { CompanyInfo } from "../pages/constants";

const NavItem = ({ url, name, onClick }) => (
  <Button
    disableRipple
    variant="outlined"
    color="inherit"
    component={NavLink}
    to={url}
    onClick={onClick}
    sx={{
      textTransform: "none",
      fontSize: 16,
      letterSpacing: 0.5,
      fontWeight: 350,
    }}
  >
    {name}
  </Button>
);

NavItem.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default function Header() {
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const [scrolled, setScrolled] = useState(false); // Track the scroll state

  const Links = [
    { name: "Partner with us", url: "/" },
    { name: "BioLNG in Transport", url: "/bio-lng-in-transport" },
    // { name: "Contact", url: "/contact" },
  ];

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {Links.map((link) => (
        <MenuItem
          key={link.url}
          component={NavLink}
          to={link.url}
          onClick={handleMobileMenuClose}
        >
          {link.name}
        </MenuItem>
      ))}
    </Menu>
  );

  // Detect scroll event to change header style
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true); // Add background and elevation on scroll
      } else {
        setScrolled(false); // Remove background and elevation
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: scrolled ? "rgba(0, 0, 0, 0.8)" : "transparent", // Apply transparent or solid background based on scroll
        boxShadow: scrolled ? 3 : 0, // Apply elevation on scroll
        transition: "background-color 0.3s, box-shadow 0.3s", // Smooth transition for background and shadow
      }}
    >
      <Box>
        <Toolbar>
          {/* Logo (CompanyName) on the left for all screen sizes */}
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "flex" },
              justifyContent: "flex-start",
            }}
          >
            <Button
              disableRipple
              color="inherit"
              component={NavLink}
              to="/"
              sx={{ textTransform: "none" }}
            >
              <img src={Logo} alt="logo" loading="lazy" height={50} />{" "}
              <Typography
                variant="body1"
                sx={{
                  marginLeft: 1,
                }}
              >
                {CompanyInfo.name}
              </Typography>
            </Button>
          </Typography>

          {/* Desktop Menu */}
          <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
            {Links.map((link) => (
              <NavItem key={link.url} url={link.url} name={link.name} />
            ))}
          </Box>
          {/* Mobile Burger Menu on the right */}
          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              justifyContent: "flex-end",
            }}
          >
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              aria-label="menu"
              aria-controls="mobile-menu"
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
            >
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </Box>
      {renderMobileMenu}
    </AppBar>
  );
}
